var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.config.show.plus_info)?_c('b-alert',{attrs:{"variant":"info","show":""}},[_c('span',{domProps:{"innerHTML":_vm._s(`${_vm.$t(_vm.random_announcement())} ${_vm.$t("foundation_link")}`)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }